.common-page-selector {
  margin: 0;

  .selected-page {
    display: flex;
    align-items: center;

    .page-type-icon {
      padding-right: 5px;
    }
    .page-details {
      .title {
      }
      .url {
      }
    }
  }
}
